import React, { useContext, useEffect, useState } from "react";
import * as PropsTypes from "prop-types";
import NotificationsItem from "../Item";
import { Grid } from "@material-ui/core";
import { ColProps_1 } from "@core/utils/ColProps";
import { __t } from "@core/translation/translation";
import Typography from "@components/Typography";
import Button from "@components/Button";
import useStyles from "./styles";
import { Link } from "react-router-dom";
import notificationApi from "@api/notification";
import { notification } from "@core/helper/notificationHelper";
import { UpdateSettingContext } from "@context/UpdateSettingProvider";

const numberOfNotification = 5;

const NotificationsList = ({ setAnchorEl }) => {
  const classes = useStyles();
  const UpdateSetting = useContext(UpdateSettingContext);
  const [state, setState] = useState({
    unReadNotifications: [],
    is_fetch: false,
  });

  useEffect(() => {
    notificationApi
      .getUnReadNotifications({
        params: {
          pageSize: numberOfNotification,
          pageNumber: 0,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          unReadNotifications: data.content,
          is_fetch: true,
        }));
      })
      .catch((data) => {
        notification(
            "",
            "danger",
            !!data && !!data?.message ? data?.message : "SERVER ERROR"
          );
      });
  }, [UpdateSetting.updateNotification]);

  const handleDelete = () => {
    notificationApi
      .deleteAll()
      .then((data) => {
        notification("", "success", data?.message);
        UpdateSetting.setUpdateNotification(!UpdateSetting.updateNotification);
      })
      .catch((data) => {
        notification(
            "",
            "danger",
            !!data && !!data?.message ? data?.message : "SERVER ERROR"
          );
      });
  };
  return (
    <Grid container direction="column" spacing={10}>
      <Grid
        item
        {...ColProps_1}
        container
        justify="space-between"
        alignItems="center"
        className={classes.header}
      >
        <Grid item>
          {state.unReadNotifications?.length > 0 && (
            <Button
              onClick={() => handleDelete()}
              size="small"
              className={classes.Btn}
            >
              <Typography color="secondary.tint100">
                {__t("Delete All")}
              </Typography>
            </Button>
          )}
        </Grid>
        <Grid item className={classes.iconContainer}>
          <div className={classes.iconBtn}>
            <Typography color="secondary.tint100">
              {__t("News and Announcements")}
            </Typography>
            <i className="icon-bell-fill" />
          </div>
        </Grid>
      </Grid>
      <Grid item {...ColProps_1} className={classes.content}>
        <NotificationsItem
          unReadNotifications={state.unReadNotifications}
          is_fetch={state.is_fetch}
          setAnchorEl={setAnchorEl}
        />
      </Grid>
      <Grid item {...ColProps_1} className={classes.bottomButtons}>
        <div className={classes.iconBtn}>
          <Link to="/notifications-management">
            <Button onClick={() => setAnchorEl(null)} size="small">
              <Typography isBold color="secondary.main">
                {__t("Notifications Settings")}
              </Typography>
              <i className="icon-setting-fill" />
            </Button>
          </Link>
        </div>
        <div onClick={() => setAnchorEl(null)} className={classes.iconBtn}>
          <Link to="/announcements/warnings">
            <Button size="small">
              <Typography isBold color="secondary.main">
                {__t("Alarms")}
              </Typography>
              <i className="icon-megaphone-fill" />
            </Button>
          </Link>
        </div>
      </Grid>
    </Grid>
  );
};

NotificationsList.propTypes = {
  list: PropsTypes.array.isRequired,
};

export default NotificationsList;
